import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import customerReducer from "../features/cutomers/customerSlice";
import enquiryReducer from "../features/enquiry/enquirySlice";
import bookingReducer from "../features/booking/bookingSlice";
 
export const store = configureStore({
  reducer: {
    auth: authReducer,
    customer: customerReducer,
    enquiry: enquiryReducer,
    booking: bookingReducer,
  },
});

